import React from 'react';

class MenuTreeItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onItemToggleOpen = this.onItemToggleOpen.bind(this);
  }

  onMouseEnter() {
    this.setState({
      hover: true,
    });
  }

  onMouseLeave() {
    this.setState({
      hover: false,
    });
  }

  onItemToggleOpen(e) {
    e.stopPropagation();
    this.props.loadSubSections({ _id: this.props.id });
  }

  render() {
    var style = { cursor: 'pointer' };
    var buttons;
    if (this.props.showButtons) {
      buttons = (
        <span className="buttons">
          <a
            href="javascript:;"
            className="sub-drop"
            onClick={this.props.createSubNode.bind(null, this.props.id)}
          >
            <span style={style} className="text-primary fa fa-plus" />
          </a>
          &nbsp;
          <a
            href="javascript:;"
            className="sub-drop"
            onClick={this.props.editSection.bind(null, this.props.id)}
          >
            <span style={style} className="text-primary fa fa-pencil" />
          </a>
          &nbsp;
          <a
            href="javascript:;"
            className="sub-drop"
            onClick={this.props.moveSection.bind(null, this.props.id)}
          >
            <span style={style} className="text-primary fa fa-list" />
          </a>
        </span>
      );
    }

    let icon = (
      <a
        onClick={this.onItemToggleOpen}
        href="javascript:void(0);"
        style={style}
      >
        <i className="fa fa-arrow-right" />
      </a>
    );
    let link;
    if (this.props.id === this.props.currentSectionId) {
      link = (
        <strong>
          <a onClick={this.props.onItemClick}>{this.props.name}</a>
        </strong>
      );
    } else {
      link = (
        <a onClick={this.props.onItemClick} style={style}>
          {this.props.name}
        </a>
      );
    }

    return (
      <li onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        {icon}
        &nbsp;&nbsp;
        {link} {this.state.hover ? buttons : null}
        {this.props.children}
      </li>
    );
  }
}

class MenuTreeNode extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openedSections: [],
    };

    this.willSubSectionsLoad = this.willSubSectionsLoad.bind(this);
  }

  willSubSectionsLoad(data) {
    // let openedSections = this.state.openedSections;

    // let section_id = data._id;
    // if (openedSections[section_id]) {
    //     this.closeSection(openedSections, section_id);
    // } else {
    //     this.loadSubSections(data);
    //     openedSections[section_id] = {"children": [], "parent": null};
    //     if (data.parent) {
    //         openedSections[section_id]["parent"] = data.parent;
    //         openedSections[data.parent]["children"].push(section_id);
    //     }
    // }

    // this.setState({
    //     openedSections: openedSections
    // })

    let openedSections = this.state.openedSections.slice();
    let index = openedSections.indexOf(data._id);
    if (index === -1) {
      this.props.loadSubSections(data);
      openedSections.push(data._id);
      this.setState({
        openedSections: openedSections,
      });
    } else {
      openedSections.splice(index, 1);
      this.setState({
        openedSections: openedSections,
      });
    }
  }

  closeSection(openedSections, section_id) {
    if (openedSections[section_id]['children'].length > 0) {
      openedSections[section_id]['children'].forEach(subSectionId => {
        this.closeSection(openedSections, subSectionId);
      });
    }

    if (openedSections[section_id]['parent']) {
      let index = openedSections[openedSections[section_id]['parent']][
        'children'
      ].indexOf(section_id);
      openedSections[openedSections[section_id]['parent']]['children'].splice(
        index,
        1,
      );
    }
    delete openedSections[section_id];
  }

  render() {
    const items = [];
    for (let item of this.props.items) {
      let subnode = null;
      if (item.sections && this.state.openedSections.indexOf(item._id) > -1) {
        subnode = (
          <MenuTreeNode
            showButtons={this.props.showButtons}
            currentSectionId={this.props.currentSectionId}
            onItemClick={this.props.onItemClick.bind(this)}
            items={item.sections}
            loadSubSections={this.willSubSectionsLoad}
            createSubNode={this.props.createSubNode}
            editSection={this.props.editSection}
            moveSection={this.props.moveSection}
          />
        );
      }
      items.push(
        <MenuTreeItem
          showButtons={this.props.showButtons}
          name={item.name}
          id={item._id}
          currentSectionId={this.props.currentSectionId}
          key={item._id}
          onItemClick={this.props.onItemClick.bind(this, item)}
          loadSubSections={this.willSubSectionsLoad}
          createSubNode={this.props.createSubNode}
          editSection={this.props.editSection}
          moveSection={this.props.moveSection}
        >
          {subnode}
        </MenuTreeItem>,
      );
    }
    return <ul className="tree tree-component">{items}</ul>;
  }
}

class MenuTree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openPath: [],
    };
  }

  onItemClick(item) {
    this.props.onItemClick(item);
  }

  loadSubSections(item) {
    this.props.onItemToggleOpen(item);
  }

  render() {
    let curSectionId = -1;
    if (this.props.currentSection) {
      curSectionId = this.props.currentSection._id;
    }
    return (
      <MenuTreeNode
        showButtons={this.props.showButtons}
        currentSectionId={curSectionId}
        onItemClick={this.onItemClick.bind(this)}
        items={this.props.tree}
        loadSubSections={this.loadSubSections.bind(this)}
        createSubNode={this.props.createSubNode}
        editSection={this.props.editSection}
        moveSection={this.props.moveSection}
      />
    );
  }
}

export default MenuTree;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/MenuTree.jsx